export var AverageUnit;
(function (AverageUnit) {
    AverageUnit[AverageUnit["Bytes"] = 0] = "Bytes";
    AverageUnit[AverageUnit["GigaBytes"] = 1] = "GigaBytes";
})(AverageUnit || (AverageUnit = {}));
export var PlanUpdateModals;
(function (PlanUpdateModals) {
    PlanUpdateModals[PlanUpdateModals["AutoUpgrade"] = 0] = "AutoUpgrade";
    PlanUpdateModals[PlanUpdateModals["ManualUpgrade"] = 1] = "ManualUpgrade";
    PlanUpdateModals[PlanUpdateModals["Downgrade"] = 2] = "Downgrade";
    PlanUpdateModals[PlanUpdateModals["Customize"] = 3] = "Customize";
    PlanUpdateModals[PlanUpdateModals["AutoUpgradeSuccess"] = 4] = "AutoUpgradeSuccess";
})(PlanUpdateModals || (PlanUpdateModals = {}));
export var PlanChangeType;
(function (PlanChangeType) {
    PlanChangeType["Upgrade"] = "UPGRADE";
    PlanChangeType["Downgrade"] = "DOWNGRADE";
})(PlanChangeType || (PlanChangeType = {}));
//# sourceMappingURL=plan-details.js.map